export function Incident() {
    const name = "incident";
    const typeCode = 112;
    const fields = {
        "ticketnumber":"ticketnumber",
        "prioritycode":"prioritycode",
        "title":"title",
        "description":"description",
        "createdon":"createdon",
        "createdby":"createdby",
        "customerid":"customerid",
        "primarycontactid":"primarycontactid",
        "ownerid":"ownerid",
        "statecode":"statecode",
        "incidentid":"incidentid",
        "caseorigincode":"caseorigincode",
        "casetypecode":"casetypecode",
        "kph_department":"kph_department",
        "modifiedon":"modifiedon",
        "modifiedby":"modifiedby",
        "kph_lastresponder":"kph_lastresponder",
        "kph_lastresponse":"kph_lastresponse",
        "kph_lastresponsetime":"kph_lastresponsetime",
    }
    return{name, typeCode, fields}
}